import React, { useEffect, useState } from 'react'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useDidMount = (
  effect: React.EffectCallback,
  deps?: React.DependencyList
) => {
  const [didMount, setDidMount] = useState(false)

  useEffect(() => {
    if (didMount) {
      return effect()
    }
    setDidMount(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps ? [...deps, didMount] : [didMount])
}
